module.exports = __webpack_public_path__ + "static/img/jsz-wx-public.0a20e6fc.jpg";